import React from 'react';
import { useResolvedTheme } from '../../theme/ThemeProvider';
import './BrandLogo.css';

interface BrandLogoProps {
  /** Always the white lockup, for fixed navy backgrounds (hero, login, footer). */
  reversed?: boolean;
  /** Follow the theme: navy lockup in light mode, white lockup in dark mode. */
  adaptive?: boolean;
  className?: string;
}

/** The approved, outlined lockup: its bars form the first letter of the name. */
const BrandLogo: React.FC<BrandLogoProps> = ({ reversed = false, adaptive = false, className = '' }) => {
  const dark = useResolvedTheme() === 'dark';
  const white = reversed || (adaptive && dark);
  return (
    <img
      className={`brand-logo ${className}`.trim()}
      src={`${process.env.PUBLIC_URL}/branding/ikompete-logo${white ? '-reversed' : ''}.svg`}
      alt="iKompete"
      width="1142"
      height="231"
    />
  );
};

export default BrandLogo;
